var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFitogramCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 180 180",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#0184F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1387_93846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 132H69.3271L79.6426 116.188H60.3156L50 132ZM50.7022 63.812H119.601L130 48H61.1014L50.7022 63.812ZM69.1432 97.906H115.137L125.536 82.094H79.4587L69.1432 97.906Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1387_93846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 84,
    fill: "white",
    transform: "translate(50 48)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFitogramCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FitogramCircle.7c828840.svg";
export { ForwardRef as ReactComponent };